export default {
    install: (app, options) => {
        app.prototype.$checkIf_value_isValid = (value) => {
            var returnValue = value.value
            var invalid = false;
            var invalidityReason = undefined;

            if ((value.value == null) || (value.value == 'null')) {
                value.value = '';
                returnValue = '';
            }

            if ((value.value instanceof String) == false) {
                value.value = value.value.toString();
            }

            if (value.value.length > 0) {
                if ((value.dataType == app.prototype.$dataTypes.integer) || (value.dataType == app.prototype.$dataTypes.decimal)) {
                    let couldBeANumber = true;

                    if ((value.permissibleValueRange.maximum.value == null) || (value.permissibleValueRange.maximum.operator == null)) {
                        value.permissibleValueRange.maximum.value = 2147483647;
                        value.permissibleValueRange.maximum.operator = app.prototype.$operators.lessThanOrEqualTo;
                    }

                    if (value.value.split('.').length == 2) {
                        if (value.value.split('.')[1].length == 0) {
                            couldBeANumber = false;
                        }
                    }

                    if ((Number.isNaN(Number(value.value)) == false) && couldBeANumber) {

                        var decimalPlaces = 0;
                        if ((value.value).indexOf(',') > 0) {
                            decimalPlaces = String(value.value).length - 1 - String(value.value).indexOf(',');
                        }
                        else if ((value.value).indexOf('.') > 0) {
                            decimalPlaces = String(value.value).length - 1 - String(value.value).indexOf('.');
                        }

                        returnValue = Number(value.value).toFixed(decimalPlaces)
                        if ((value.permissibleValueRange.minimum.value != null) && (value.permissibleValueRange.maximum.value != null)) {
                            if ((value.permissibleValueRange.minimum.operator == app.prototype.$operators.greaterThanOrEqualTo) && (value.permissibleValueRange.maximum.operator == app.prototype.$operators.lessThanOrEqualTo)) {
                                if ((Number(value.value) < Number(value.permissibleValueRange.minimum.value)) || (Number(value.value) > Number(value.permissibleValueRange.maximum.value))) {
                                    invalid = true
                                    invalidityReason = app.prototype.$invalidityReasons.outOfPermissibleValueRange
                                }
                                else {
                                    const response = app.prototype.$checkIf_value_correspondsToDataType({ 'value': value.value, 'dataType': value.dataType, 'permissibleNumberOfDecimalPlaces': value.permissibleNumberOfDecimalPlaces })
                                    invalid = response.invalid
                                    invalidityReason = response.invalidityReason
                                }
                            }
                            else if ((value.permissibleValueRange.minimum.operator == app.prototype.$operators.greaterThanOrEqualTo) && (value.permissibleValueRange.maximum.operator == app.prototype.$operators.lessThan)) {
                                if ((Number(value.value) < Number(value.permissibleValueRange.minimum.value)) || (Number(value.value) >= Number(value.permissibleValueRange.maximum.value))) {
                                    invalid = true
                                    invalidityReason = app.prototype.$invalidityReasons.outOfPermissibleValueRange
                                }
                                else {
                                    const response = app.prototype.$checkIf_value_correspondsToDataType({ 'value': value.value, 'dataType': value.dataType, 'permissibleNumberOfDecimalPlaces': value.permissibleNumberOfDecimalPlaces })
                                    invalid = response.invalid
                                    invalidityReason = response.invalidityReason
                                }
                            }
                            else if ((value.permissibleValueRange.minimum.operator == app.prototype.$operators.greaterThan) && (value.permissibleValueRange.maximum.operator == app.prototype.$operators.lessThanOrEqualTo)) {
                                if ((Number(value.value) <= Number(value.permissibleValueRange.minimum.value)) || (Number(value.value) > Number(value.permissibleValueRange.maximum.value))) {
                                    invalid = true
                                    invalidityReason = app.prototype.$invalidityReasons.outOfPermissibleValueRange
                                }
                                else {
                                    const response = app.prototype.$checkIf_value_correspondsToDataType({ 'value': value.value, 'dataType': value.dataType, 'permissibleNumberOfDecimalPlaces': value.permissibleNumberOfDecimalPlaces })
                                    invalid = response.invalid
                                    invalidityReason = response.invalidityReason
                                }
                            }
                            else if ((value.permissibleValueRange.minimum.operator == app.prototype.$operators.greaterThan) && (value.permissibleValueRange.maximum.operator == app.prototype.$operators.lessThan)) {
                                if ((Number(value.value) <= Number(value.permissibleValueRange.minimum.value)) || (Number(value.value) >= Number(value.permissibleValueRange.maximum.value))) {
                                    invalid = true
                                    invalidityReason = app.prototype.$invalidityReasons.outOfPermissibleValueRange
                                }
                                else {
                                    const response = app.prototype.$checkIf_value_correspondsToDataType({ 'value': value.value, 'dataType': value.dataType, 'permissibleNumberOfDecimalPlaces': value.permissibleNumberOfDecimalPlaces })
                                    invalid = response.invalid
                                    invalidityReason = response.invalidityReason
                                }
                            }
                            else {
                                // error
                            }
                        }
                        else if ((value.permissibleValueRange.minimum.value != null) && (value.permissibleValueRange.maximum.value == null)) {
                            if (value.permissibleValueRange.minimum.operator == app.prototype.$operators.greaterThanOrEqualTo) {
                                if (Number(value.value) < Number(value.permissibleValueRange.minimum.value)) {
                                    invalid = true
                                    invalidityReason = app.prototype.$invalidityReasons.outOfPermissibleValueRange
                                }
                                else {
                                    const response = app.prototype.$checkIf_value_correspondsToDataType({ 'value': value.value, 'dataType': value.dataType, 'permissibleNumberOfDecimalPlaces': value.permissibleNumberOfDecimalPlaces })
                                    invalid = response.invalid
                                    invalidityReason = response.invalidityReason
                                }
                            }
                            else if (value.permissibleValueRange.minimum.operator == app.prototype.$operators.greaterThan) {
                                if (Number(value.value) <= Number(value.permissibleValueRange.minimum.value)) {
                                    invalid = true
                                    invalidityReason = app.prototype.$invalidityReasons.outOfPermissibleValueRange
                                }
                                else {
                                    const response = app.prototype.$checkIf_value_correspondsToDataType({ 'value': value.value, 'dataType': value.dataType, 'permissibleNumberOfDecimalPlaces': value.permissibleNumberOfDecimalPlaces })
                                    invalid = response.invalid
                                    invalidityReason = response.invalidityReason
                                }
                            }
                            else {
                                // error
                            }
                        }
                        else if ((value.permissibleValueRange.minimum.value == null) && (value.permissibleValueRange.maximum.value != null)) {
                            if (value.permissibleValueRange.maximum.operator == app.prototype.$operators.lessThanOrEqualTo) {
                                if (Number(value.value) > Number(value.permissibleValueRange.maximum.value)) {
                                    invalid = true
                                    invalidityReason = app.prototype.$invalidityReasons.outOfPermissibleValueRange
                                }
                                else {
                                    const response = app.prototype.$checkIf_value_correspondsToDataType({ 'value': value.value, 'dataType': value.dataType, 'permissibleNumberOfDecimalPlaces': value.permissibleNumberOfDecimalPlaces })
                                    invalid = response.invalid
                                    invalidityReason = response.invalidityReason
                                }
                            }
                            else if (value.permissibleValueRange.maximum.operator == app.prototype.$operators.lessThan) {
                                if (Number(value.value) >= Number(value.permissibleValueRange.maximum.value)) {
                                    invalid = true
                                    invalidityReason = app.prototype.$invalidityReasons.outOfPermissibleValueRange
                                }
                                else {
                                    const response = app.prototype.$checkIf_value_correspondsToDataType({ 'value': value.value, 'dataType': value.dataType, 'permissibleNumberOfDecimalPlaces': value.permissibleNumberOfDecimalPlaces })
                                    invalid = response.invalid
                                    invalidityReason = response.invalidityReason
                                }
                            }
                            else {
                                // error
                            }
                        }
                        else {
                            // error
                        }
                    }
                    else {
                        invalid = true;
                        invalidityReason = app.prototype.$invalidityReasons.noNumber;
                    }
                }
                else {
                    if (value.value.length <= 1073741823) {
                        if (value.value.includes('"') || value.value.includes(',') || value.value.includes(';') || value.value.includes('<') || value.value.includes('>') || value.value.match(/\\$/)) {
                            invalid = true;
                            invalidityReason = app.prototype.$invalidityReasons.containsUnwantedCharacters;
                        }
                    }
                    else {
                        invalid = true;
                        invalidityReason = app.prototype.$invalidityReasons.characterLengthExceeded;
                    }
                }
            }
            else {
                invalid = true;
                invalidityReason = app.prototype.$invalidityReasons.notSet;
            }

            if (returnValue === '') {
                returnValue = null;
            }

            return { value: returnValue, invalid: invalid, invalidityReason: invalidityReason, permissibleNumberOfDecimalPlaces: value.permissibleNumberOfDecimalPlaces, permissibleValueRange: value.permissibleValueRange }
        }
        app.prototype.$checkIf_value_correspondsToDataType = (value) => {
            var invalid = false;
            var invalidityReason = null;

            if (value.dataType == app.prototype.$dataTypes.integer) {
                if (value.value.split('.').length > 1) {
                    invalid = true
                    invalidityReason = app.prototype.$invalidityReasons.noInteger
                }
            }
            else if (value.dataType == app.prototype.$dataTypes.decimal) {
                if (value.value.split('.').length > 1) {
                    if (value.value.split('.')[1].length > value.permissibleNumberOfDecimalPlaces) {
                        invalid = true
                        invalidityReason = app.prototype.$invalidityReasons.permissibleNumberOfDecimalPlacesExceeded
                    }
                }
            }

            return { 'invalid': invalid, 'invalidityReason': invalidityReason }
        }

        app.prototype.$set_decimalValueToLocaleString = (value) => {
            if (value.value != [] && value.value != null && isNaN(value.value) == true) {

                if (value.value.toString().slice(-1) != ",") {

                    var decimalPlaces = 0;
                    if ((value.value).indexOf(',') > 0) {
                        decimalPlaces = String(value.value).length - 1 - String(value.value).indexOf(',');
                    }
                    else if ((value.value).indexOf('.') > 0) {
                        decimalPlaces = String(value.value).length - 1 - String(value.value).indexOf('.');
                    }

                    const number = parseFloat(value.value.replace(',', '.')).toFixed(decimalPlaces);
                    if (isNaN(number) == false && number != [] && number != null) {
                        return number;
                    }
                    else {
                        return value.value;
                    }
                }
                else {
                    return value.value;
                }
            }
            else {
                return value.value;
            }
        }

        app.prototype.$get_decimalValueToLocaleString = (value) => {
            if (value.value != [] && value.value != null) {
                if (value.country == 'de') {
                    return String(value.value).replace(".", ",")
                }
                else {
                    return String(value.value).replace(",", ".")
                }
            }
            else {
                return value.value;
            }
        }

        app.prototype.$get_factorUnit = (value) => {
            var region = null;
            if (value.region != null && value.region.text.text != null) {
                region = value.region.text.text;
            }
            const number = parseFloat(value.value);
            if (region == null || value.value == null || isNaN(number) == true) {
                return value.value
            }
            const list = app.prototype.$get_unitList();
            const firstIndex_whichMeetConditions = list.findIndex(i => (i.region == region && i.default == value.default));
            if (firstIndex_whichMeetConditions == -1) {
                return value.value
            }
            var factor = list[firstIndex_whichMeetConditions].factor;
            if (factor == null || factor == 0) {
                return value.value
            }

            if (value.direction != 1) {
                factor = 1 / factor;
            }
            if (value.digits != null) {
                return (number * factor).toFixed(value.digits);
            }
            return (number * factor);
        }

        app.prototype.$get_unitList = () => {
            const list = [{ region: 'NA', default: 'kg', unit: 'lb', factor: (1 / 0.45359237) },
            { region: 'NA', default: 'm/s', unit: 'ft/min', factor: (1 / 0.00508) },
            { region: 'NA', default: 'm', unit: 'ft', factor: (1 / 0.3048) },
            { region: 'NA', default: 'Nm', unit: 'lbf', factor: (1 / 1.355868934) },
            { region: 'NA', default: 'kW', unit: 'hp', factor: (1 / 0.745699871582) },
            { region: 'NA', default: 'kg/m', unit: 'lb/ft', factor: (1 / 1.488164) },
            { region: 'NA', default: 'mm', unit: 'in.', factor: (1 / 25.4) },
            { region: 'NA', default: 'm/s²', unit: 'ft/s²', factor: (1 / 0.3048) },
            { region: 'NA', default: 'kgm²', unit: 'lb-ft²', factor: (1 / 0.04214) },
            ];

            return list;
        }

        app.prototype.$get_unit = (value) => {

            var region = value.region;
            const list = app.prototype.$get_unitList();
            const firstIndex_whichMeetConditions = list.findIndex(i => (i.region == region && i.default == value.default));
            if (firstIndex_whichMeetConditions > -1) {
                return list[firstIndex_whichMeetConditions].unit
            }
            else {
                return value.default;
            }
        }

        app.prototype.$transmit_valueAndValueValidationCriteria =
        {
            'value': null,
            'dataType': null,
            'permissibleNumberOfDecimalPlaces': null,
            'permissibleValueRange': {
                'minimum': {
                    'value': null,
                    'operator': null,
                },
                'maximum': {
                    'value': null,
                    'operator': null,
                }
            }
        }

        app.prototype.$localDecimal =
        {
            'country': null,
            'value': null
        }

        app.prototype.$dataTypes = {
            integer: 'integer',
            decimal: 'decimal',
            string: 'string',
        }
        app.prototype.$operators = {
            greaterThanOrEqualTo: 'greaterThanOrEqualTo',
            greaterThan: 'greaterThan',
            lessThanOrEqualTo: 'lessThanOrEqualTo',
            lessThan: 'lessThan',
        }
        app.prototype.$invalidityReasons = {
            notSet: 'notSet',
            noNumber: 'noNumber',
            noInteger: 'noInteger',
            containsUnwantedCharacters: 'containsUnwantedCharacters',
            characterLengthExceeded: 'characterLengthExceeded',
            outOfPermissibleValueRange: 'outOfPermissibleValueRange',
            permissibleNumberOfDecimalPlacesExceeded: 'permissibleNumberOfDecimalPlacesExceeded',
            minimumValueGreaterThanMaximumValue: 'minimumValueGreaterThanMaximumValue',
        }
    }
}

